<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [header]="'Change Availability'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '400px' }"
        (onHide)="close()"
>
    <p class="text-gray-500 dark:text-gray-300 mb-4">Set the availability of this sample for the selected vehicle model.
        If no dates are provided, the availability from the vehicle model is used.</p>
    <div class="flex justify-items-center items-center gap-2 mb-2">
        <p-ifta-label>
            <p-date-picker
                    [(ngModel)]="this.availabilityDate"
                    id="availability-date"
                    class="w-full"
                    dateFormat="dd.mm.yy"
                    appendTo="body"
            ></p-date-picker>
            <label for="availability-date">Availability Date</label>
        </p-ifta-label>
        <p-button label="Clear" (onClick)="this.clearAvailabilityDate()" severity="secondary"></p-button>
    </div>
    <div class="flex justify-items-center items-center gap-2">

        <!-- Expiration Date -->
        <p-ifta-label>
            <p-date-picker
                    [(ngModel)]="this.expirationDate"
                    id="expiration-date"
                    class="w-full"
                    dateFormat="dd.mm.yy"
                    appendTo="body"
            ></p-date-picker>
            <label for="expiration-date">Expiration Date</label>
        </p-ifta-label>
        <p-button label="Clear" (onClick)="this.clearExpirationDate()" severity="secondary"></p-button>
    </div>


    <div class="flex items-center justify-end gap-2 mt-6">
        <p-button label="Cancel" (onClick)="this.close()" severity="secondary"></p-button>
        <p-button label="Save" (onClick)="this.save()" severity="primary" [loading]="this.loading"></p-button>
    </div>
</p-dialog>
